import { PLAN_V3_CATEGORIES, getPlanCategoryLabel } from '@smarty-nx/code-utils'

const classicPlanCategoryLabel = getPlanCategoryLabel(
  PLAN_V3_CATEGORIES.CLASSIC
)

export const content = {
  mainHeading: 'All the data you need for less',
  voicePlans: {
    heading: `${classicPlanCategoryLabel}`,
    tooltipHeader: `${classicPlanCategoryLabel}`,
    tooltipLines: [
      "Your choice of data, with unlimited calls & texts. That's simple and SMARTY.",
      'As always, 1 month plans. No contracts, no credit checks and no surprises at the end of the month. Cancel or change plans anytime. Pay in advance and enjoy the flexibility.',
    ],
    tooltipEsimLine:
      'eSIM available – activate instantly, no plastic SIM needed.',
    smallHeading: 'Unlimited calls & texts. eSIM available',
  },
  dataOnlyPlans: {
    heading: 'Data Only plans',
    tooltipHeader: 'Data Only plans',
    tooltipIntro: 'No calls and texts, just great value data.',
    tooltipBullets: [
      'Use data in the UK and roaming EU countries',
      'Unrestricted hotspotting and no speed limits',
      'No contract: 1 month plan',
    ],
    tooltipEsimLine:
      'eSIM available – quick, easy setup on compatible devices.',
    tooltipNote: `Data Only plans cannot be switched or upgraded to
            ${classicPlanCategoryLabel} or Money Back plans just yet.`,
    smallHeading: 'Just great value data. eSIM available',
  },
}
